/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesAuthAuthenticateFromEmailInviteResponse interface.
 */
export function instanceOfFxIdWebFeaturesAuthAuthenticateFromEmailInviteResponse(value) {
    if (!('Success' in value) || value['Success'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesAuthAuthenticateFromEmailInviteResponseFromJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromEmailInviteResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromEmailInviteResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Success': json['Success'],
        'Error': json['Error'] == null ? undefined : json['Error'],
        'Token': json['Token'] == null ? undefined : json['Token'],
        'RedirectUri': json['RedirectUri'] == null ? undefined : json['RedirectUri'],
    };
}
export function FxIdWebFeaturesAuthAuthenticateFromEmailInviteResponseToJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromEmailInviteResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromEmailInviteResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Success': value['Success'],
        'Error': value['Error'],
        'Token': value['Token'],
        'RedirectUri': value['RedirectUri'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesAuthAuthenticateFromEmailInviteResponse.js.map